import { colors } from '../../../shared/styles/baseStyle';

export const button = {
  height: 48,
  borderRadius: 10,
  fontWeight: 600,
  border: 'none',
  color: 'white'
};
export const resendButton = {
  color: colors.anytimeBlue,
  fontWeight: 600,
  padding: 4,
  height: 'auto'
};
export const remainingTimeText = {
  display: 'block',
  textAlign: 'center',
  marginTop: 32
};
export const remainingTimeColor = { color: colors.anytimeBlue };
export const expireText = {
  display: 'block',
  textAlign: 'center'
};
export const space = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 32
};
